'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutContainer, Section } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { useMemo } from 'react';
import { useViewItemListImpressions } from '@libs/analytics';
import { type FrefListCodes } from '@libs/common-next';
import { type BuyItAgainItem } from '@libs/common-types';
import { CarouselProductCard } from './components';
import { mapBuyItAgainViewItems, type ViewItemListAttribution } from './hooks';
import './buy-it-again-carousel.scss';
const MAX_VISIBLE_PRODUCTS = 6;
const HOME_FREF_ATTRIBUTION: FrefListCodes = {
  listId: 'splp',
  listName: 'bia'
};
type BuyItAgainCarouselProps = {
  readonly header: string;
  readonly subheader?: string;
  readonly products: BuyItAgainItem[] | undefined;
  readonly minCount: number;
  readonly className?: string;
  readonly excludes?: readonly string[];
  readonly frefAttribution?: FrefListCodes;
  /**
   * Opts the carousel into batched `view_item_list` impressions (e.g. Cart BIA).
   * When omitted, each card keeps the standalone Home Page impression event.
   */
  readonly viewItemList?: ViewItemListAttribution;
};
export function BuyItAgainCarousel(t0) {
  const $ = _c(34);
  const {
    header,
    subheader,
    products,
    minCount,
    className,
    excludes: t1,
    frefAttribution: t2,
    viewItemList
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const excludes = t3;
  const frefAttribution = t2 === undefined ? HOME_FREF_ATTRIBUTION : t2;
  let t4;
  if ($[2] !== excludes) {
    t4 = new Set(excludes);
    $[2] = excludes;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const excludedSkus = t4;
  let eligibleProducts;
  let t5;
  if ($[4] !== excludedSkus || $[5] !== products) {
    eligibleProducts = products?.filter(product => !excludedSkus.has(product.sku));
    t5 = (eligibleProducts ?? []).slice(0, MAX_VISIBLE_PRODUCTS);
    $[4] = excludedSkus;
    $[5] = products;
    $[6] = eligibleProducts;
    $[7] = t5;
  } else {
    eligibleProducts = $[6];
    t5 = $[7];
  }
  const visibleProducts = t5;
  let t6;
  if ($[8] !== viewItemList || $[9] !== visibleProducts) {
    t6 = viewItemList ? mapBuyItAgainViewItems(visibleProducts, viewItemList) : [];
    $[8] = viewItemList;
    $[9] = visibleProducts;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const impressionItems = t6;
  let t7;
  if ($[11] !== impressionItems) {
    t7 = {
      items: impressionItems
    };
    $[11] = impressionItems;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const {
    onVisible
  } = useViewItemListImpressions(t7);
  if (!eligibleProducts || eligibleProducts.length < minCount) {
    return null;
  }
  let t8;
  if ($[13] !== className) {
    t8 = cn("buy-it-again-carousel", className);
    $[13] = className;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== frefAttribution || $[16] !== onVisible || $[17] !== viewItemList || $[18] !== visibleProducts) {
    let t10;
    if ($[20] !== frefAttribution || $[21] !== onVisible || $[22] !== viewItemList) {
      t10 = (product_0, index) => <li key={product_0.sku}><CarouselProductCard recommendation={product_0} position={index + 1} frefAttribution={frefAttribution} onView={viewItemList ? () => onVisible(index) : undefined} /></li>;
      $[20] = frefAttribution;
      $[21] = onVisible;
      $[22] = viewItemList;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    t9 = visibleProducts.map(t10);
    $[15] = frefAttribution;
    $[16] = onVisible;
    $[17] = viewItemList;
    $[18] = visibleProducts;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[24] !== header || $[25] !== t9) {
    t10 = <ul className="buy-it-again-carousel__products" aria-label={header}>{t9}</ul>;
    $[24] = header;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== header || $[28] !== subheader || $[29] !== t10) {
    t11 = <Section align="center" headingTagName="h2" title={header} description={subheader}>{t10}</Section>;
    $[27] = header;
    $[28] = subheader;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t8) {
    t12 = <LayoutContainer className={t8}>{t11}</LayoutContainer>;
    $[31] = t11;
    $[32] = t8;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
}